import { useState } from "react";
import { Tabs } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import UploadEntryTab from "./UploadEntryTab";
import ReconciliationTab from "./ReconciliationTab";
import YetToPayTab from "./YetToPayTab";
import ApprovedTab from "./ApprovedTab";
import "./Transactions.css";

const SECTIONS = {
  DATA_ENTRY: "data-entry",
  TRANSACTIONS: "transactions",
};

const DATA_ENTRY_TABS = [
  { key: "upload-entry", label: "Upload & Entry" },
  { key: "reconciliation", label: "Reconciliation" },
];

const TRANSACTION_TABS = [
  { key: "yet-to-pay", label: "Yet to Pay" },
  { key: "approved", label: "Approved" },
];

export default function Transactions() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState(SECTIONS.DATA_ENTRY);
  const [activeTab, setActiveTab] = useState("upload-entry");

  const handleSectionChange = (section) => {
    setActiveSection(section);
    setActiveTab(
      section === SECTIONS.DATA_ENTRY ? "upload-entry" : "yet-to-pay"
    );
  };

  const tabs =
    activeSection === SECTIONS.DATA_ENTRY ? DATA_ENTRY_TABS : TRANSACTION_TABS;

  const renderTabContent = () => {
    switch (activeTab) {
      case "upload-entry":
        return <UploadEntryTab />;
      case "reconciliation":
        return <ReconciliationTab />;
      case "yet-to-pay":
        return <YetToPayTab />;
      case "approved":
        return <ApprovedTab />;
      default:
        return null;
    }
  };

  return (
    <div>
      <div className="tx-dual-banner">
        <button
          type="button"
          className="tx-banner-back"
          onClick={() => navigate("/dashboard")}
          aria-label="Back"
        >
          <LeftOutlined />
        </button>
        <div
          className={`tx-banner-half ${
            activeSection === SECTIONS.DATA_ENTRY ? "on" : "off"
          }`}
          onClick={() => handleSectionChange(SECTIONS.DATA_ENTRY)}
        >
          <span className="tx-banner-text">DATA ENTRY</span>
        </div>
        <div
          className={`tx-banner-half ${
            activeSection === SECTIONS.TRANSACTIONS ? "on" : "off"
          }`}
          onClick={() => handleSectionChange(SECTIONS.TRANSACTIONS)}
        >
          <span className="tx-banner-text">TRANSACTIONS</span>
        </div>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabs}
        className="tx-tabs"
      />

      <div className="tx-content">{renderTabContent()}</div>
    </div>
  );
}
